<template>
    <div class="router-view-content" ref="content">
        <div style="display: flex; justify-content: space-between;">
            <h2>Kreator</h2>
            <div style="display: flex; align-items: center">
                <CheckBox
                    style="margin-right: 1rem"
                    color="apple"
                    @input="setManualAssets"
                    v-model="manualAssets"
                />
                <p>Migracja webinaru</p>
            </div>
            <div v-if="editing">
                <ActionButton
                    materialIcon="delete"
                    label="Usuń konferencję"
                    color="red"
                    @click="removeConference"
                    :loading="removalLoading"
                />
            </div>
        </div>
        <EditSection
            accent="apple"
            title="Podstawa"
            :errors="errors"
            :sections="mainSection"
            ref="mainSection"
            section="mainSection"
        />
        <ActionButton
            :loading="loading"
            @click="submit"
            style="margin-top: 3rem;"
            color="apple"
            :label="editing ? 'Zapisz zmiany' : 'Utwórz konferencję'"
        />
    </div>
</template>
<script>
export default {
    data() {
        return {
            loading: false,
            removalLoading: false,
            manualAssets: false,
            errors: new this.$Errors(),
            mainSection: {
                title: {
                    required: true,
                    title: 'Tytuł',
                    value: '',
                    type: 'text-input',
                    key: 'title',
                    color: '#FFF',
                    size: 3
                },
                description: {
                    title: 'Opis',
                    value: '',
                    type: 'text-editor',
                    key: 'description',
                    color: '#FFF',
                    size: 3
                },
                subtitle: {
                    required: true,
                    title: 'Podtytuł',
                    value: '',
                    type: 'text-input',
                    key: 'subtitle',
                    color: '#FFF',
                    size: 1
                },
                uuid: {
                    required: false,
                    title: 'UUID',
                    value: '',
                    type: 'text-input',
                    key: 'uuid',
                    color: '#FFF',
                    size: 1
                },
                visible: {
                    title: 'Widoczny dla userów?',
                    value: false,
                    options: {
                        false: this.$t('SWITCHER_NO'),
                        true: this.$t('SWITCHER_YES')
                    },
                    type: 'switch',
                    key: 'visible',
                    color: '#FFF',
                    size: 1
                },
                cost: {
                    required: true,
                    title: 'Koszt',
                    value: 0,
                    type: 'number-input',
                    key: 'cost',
                    color: '#FFF',
                    size: 1
                },
                old_cost: {
                    required: false,
                    title: 'Koszt promocyjny',
                    value: 0,
                    type: 'number-input',
                    key: 'old_cost',
                    color: '#FFF',
                    size: 1
                },
                thumbnail: {
                    title: 'Miniaturka',
                    value: '',
                    type: 'attachments-input',
                    single: true,
                    key: 'thumbnail',
                    color: '#FFF',
                    size: 2
                }
            }
        }
    },
    computed: {
        currentConference() {
            return this.$route.params.conference
        },
        editing() {
            return this.currentConference != 'new'
        }
    },
    methods: {
        setManualAssets() {
            const assetInputType = this.manualAssets
                ? 'text-input'
                : 'attachments-input'
            const textInputType = this.manualAssets
                ? 'area-input'
                : 'text-editor'
            this.mainSection.thumbnail.type = assetInputType
            this.mainSection.description.type = textInputType
        },
        removeConference() {
            if (this.removalLoading) {
                return
            }
            this.removalLoading = true
            this.$api
                .remove(`v1/vod/conferences/${this.currentConference}`)
                .then(() => {
                    this.$router.push('/support/conferences')
                })
                .catch(error => {
                    this.$Network.handleError(error)
                    this.removalLoading = false
                })
        },
        async submit() {
            if (this.loading) {
                return
            }
            let data = {}
            await this.$refs.mainSection.uploadFiles()
            if (!this.$Utils.setForm(this.mainSection, data, this.errors)) {
                return
            }

            data.cost = parseInt(data.cost)
            data.old_cost = parseInt(data.old_cost)
            data.webinars = []
            this.loading = true
            try {
                if (this.editing) {
                    await this.$api.patch(
                        `v1/vod/conferences/${this.currentConference}`,
                        data
                    )
                } else {
                    await this.$api.post(`v1/vod/conferences`, data)
                }
                await this.$store.dispatch('content/getConferences')
                this.$router.push('/support/conferences')
                this.loading = false
            } catch (error) {
                this.$Network.handleError(error, this.errors)
                this.loading = false
            }
        },
        setForm() {
            if (!this.currentConference || this.currentConference == 'new') {
                return
            }
            const conference = this.$store.state.content.conferences.find(
                w => w.id == this.currentConference
            )
            Object.keys(this.mainSection).forEach(key => {
                if (this.mainSection[key] && conference[key] != undefined) {
                    this.mainSection[key].value = conference[key]
                }
            })
        },
        close() {
            this.$emit('close')
        }
    },
    mounted() {
        this.setForm()
    }
}
</script>
